import { Button, Col, Empty, Row, Spin } from "antd";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthModalContext } from "../../Contexts/AuthModalContext";
import { ConfigContext } from "../../Contexts/ConfigContext";
import {
  BestSellingProducts,
  BringChangeSlider,
  CouponSlider,
  GoogleReviewSlider,
  JoinWhatsapp,
  LandingFAQ,
  LifeChangeSlider,
  PopularBrandsSlider,
  RecommendedProducts,
} from "../../Views/LandingV2/LandingV2";
import {
  regional_recipes_slider,
  upcoming_categories_slider,
} from "../../Views/LandingV2/data";
import {
  asList,
  useCatalogQuery,
  useCategories,
  useDiscountedProducts,
  useNewProducts,
} from "../../Hooks/useProductsBySubCategory";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import { FeatureFlag } from "../FeatureFlag/FeatureFlag";
import Layout from "../Layout/Layout";
import MostLikesCategories from "../MostLikesCategories/MostLikesCategories";
import BetaSlider from "../Sliders/BetaSlider/BetaSlider";
import ProductSlider from "../Sliders/ProductSlider/ProductSlider";
import styles from "./Categories.module.scss";
import atta from "./images/atta.png";
import immunity from "./images/immunity.png";
import member_chevron from "./images/member_chevron.svg";
import { Typography } from "antd";

const Categories = () => {
  const [activeSubCategory, setActiveSubCategory] = useState("");

  //   check is desktop initial and on scroll
  const isDesktop = window.innerWidth > 991;

  // slider data, same cache entries as the landing page sliders
  const { products: discountedProducts } = useDiscountedProducts();
  const { products: newProducts } = useNewProducts();
  const { setShowLocModal } = useContext(ConfigContext);
  const { openRegister } = useContext(AuthModalContext);

  const { categories, loading: categoryLoading } = useCategories();
  const activeCategory = categories[0]?.id ?? null;

  // subcategories of the active category
  const { data: subcategoryData, loading: subcategoryLoading } =
    useCatalogQuery("/public/subcategories", {
      params: { category: activeCategory },
      transform: asList,
      enabled: !!activeCategory,
    });
  const subcategoryByCategory = subcategoryData ?? [];
  const subCategoryLoading =
    categoryLoading || (!!activeCategory && subcategoryLoading);

  const renderSubcategories = (subcategories) => {
    return (
      <Row gutter={[20, 20]} className={styles.subcat_container}>
        {subcategories.length > 0 ? (
          <>
            {subcategories.map((subcategory, index) => (
              <Col xs={8} md={6} key={index} flex={isDesktop ? "20%" : null}>
                <Link
                  to={`/category/${subcategory.slug}_${subcategory.id}`}
                  className={
                    activeSubCategory === subcategory.id
                      ? styles.subcategory_item_active
                      : styles.subcategory_item_active
                  }
                  key={index}
                  onClick={() => {
                    setActiveSubCategory(subcategory.id);
                  }}
                >
                  <div className={styles.subcat_image_container}>
                    <img src={subcategory.image} alt={index} />
                  </div>
                  <span>{subcategory.name}</span>
                </Link>
              </Col>
            ))}
          </>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{
              height: 550,
            }}
          >
            <Empty description="No category found!" />
          </div>
        )}
      </Row>
    );
  };

  const renderGroupedCategories = () => {
    return categories.map((category) => {
      const subcategories = subcategoryByCategory.filter(
        (subcat) => subcat.category === category.id,
      );
      if (subcategories.length === 0) return null;
      return (
        <div key={category.id}>
          <Typography.Title level={4} style={{ margin: 0, marginBottom: 10 }}>
            {category.name}
          </Typography.Title>
          {renderSubcategories(subcategories)}
        </div>
      );
    });
  };

  return (
    <Layout>
      <div className={`container ${styles.container}`}>
        <Row>
          <Col xs={0} lg={24} style={{ marginTop: 15 }}>
            <BreadCrumb
              list={[
                { name: "Back to Home", link: "/" },
                {
                  name: "All Categories",
                  link: "/categories",
                },
              ]}
            />
          </Col>
        </Row>
        <Row gutter={[15, 15]} className={styles.categories}>
          <Col
            xs={24}
            lg={14}
            offset={isDesktop ? 1 : 0}
            style={{
              paddingLeft: isDesktop && "3.5rem",
              paddingRight: !isDesktop ? "0" : "7.5px",
            }}
          >
            {subCategoryLoading ? (
              <div className={styles.categories_loading}>
                <Spin />
              </div>
            ) : window.innerWidth < 576 ? (
              renderGroupedCategories()
            ) : (
              renderSubcategories(subcategoryByCategory)
            )}
          </Col>

          <Col lg={7} xs={24}>
            <Row
              gutter={[20, 20]}
              className={`${styles.category_item_container_right} hide_mobile`}
            >
              <Col span={24}>
                <Link to={"/"} className={styles.cat_banner_wrapper}>
                  <img src={atta} alt="atta" className={styles.cat_right_img} />
                </Link>
              </Col>
              <Col span={24}>
                <Link
                  to={"/"}
                  className={`${styles.cat_banner_wrapper} hide_mobile`}
                >
                  <img
                    src={immunity}
                    alt="immunity"
                    className={styles.cat_right_img}
                  />
                </Link>
              </Col>

              <Col span={24}>
                <div className={styles.cat_banner_wrapper}>
                  <button className={styles.member_button} onClick={() => openRegister({ dfCard: true })}>
                    <span>Become a member now</span>
                    <img src={member_chevron} alt="chevron" />
                  </button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col xs={0} lg={24}>
            {/* discounts and offers slider */}
            <ProductSlider
              title={"Discounts & Offers"}
              link={"/"}
              products={discountedProducts}
              showDiscountVariants
            />

            <br />

            {/*Change Live Section*/}
            <LifeChangeSlider />

            {/*Coupon Slider*/}
            <FeatureFlag name="landingCouponSection">
              <div className="mt-5" />
              <CouponSlider />
            </FeatureFlag>

            {/* new products slider slider */}
            <div className="mt-5" />
            <ProductSlider
              title={"New Products"}
              link={"/"}
              products={newProducts}
            />

            {/*Most Liked Categories Slider*/}
            <div className="mt-4" />
            <MostLikesCategories />

            {/*Regional Recipes*/}
            <FeatureFlag name="landingRegionalRecipesSection">
              <BetaSlider
                slides={regional_recipes_slider}
                title={"Regional Recipes"}
                link={"/"}
              />
            </FeatureFlag>

            {/*Delivery Location Map*/}
            <section className={styles.delivery_map}>
              <h2>We deliver across Germany</h2>
              <img src="/delivery-map.png" alt="" />
              <em>Where are you based?</em>
              <span>Help us to deliver you fast</span>
              <Button type={"primary"} onClick={() => setShowLocModal(true)}>
                Choose Location
              </Button>
            </section>

            {/*Bring Change Slider*/}
            <BringChangeSlider />

            {/* recommended products slider */}
            <div className="mt-5"></div>
            <RecommendedProducts />

            {/* most selling items slider */}
            <div className="mt-5"></div>
            <BestSellingProducts />

            {/*Brands Slider*/}
            <div className="mt-5"></div>
            <PopularBrandsSlider />

            {/*Upcoming Categories Slider*/}
            <br />
            <BetaSlider
              slides={upcoming_categories_slider}
              title={`Upcoming Categories`}
              link={"/"}
            />

            {/*Whatsapp Section*/}
            <JoinWhatsapp />

            {/*Review Section*/}
            <GoogleReviewSlider />

            {/*FAQ Section*/}
            <LandingFAQ />
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default Categories;
